<div class="page-body">
  <div class="row">
    <!-- Right column start -->

    <div class="col-xl-3 col-lg-12 push-xl-9">
      <!-- Search box card start -->
      <div class="card">
        <div class="card-header">
          <h5 class="card-header-text">User Search Box</h5>
        </div>
        <div class="card-body p-t-10">
          <div>
            <form class="j-pro form-control md-float-material" id="j-pro">
              <div class="j-input">
                <tag-input
                  [ngClass]="'tag-select'"
                  theme="bootstrap"
                  [formControl]="inviteUsersField"
                  [maxItems]="1"
                  [placeholder]="'Enter name of user'"
                  [onTextChangeDebounce]="500"
                  [secondaryPlaceholder]="'Search for users'"
                  [onlyFromAutocomplete]="false"
                >
                  <tag-input-dropdown
                    [autocompleteItems]="inviteUsers"
                    [limitItemsTo]="10"
                    [minimumTextLength]="0"
                    [displayBy]="'username'"
                    [identifyBy]="'_id'"
                    [showDropdownIfEmpty]="false"
                    [focusFirstElement]="true"
                  >
                    <ng-template let-item="item" let-index="index">
                      {{ item.username }}
                    </ng-template>
                  </tag-input-dropdown>
                </tag-input>
              </div>
            </form>
          </div>
          <!-- end of sidebar-right -->
        </div>
        <!-- end of card-body -->
      </div>
      <!-- Search box card end -->
    </div>
    <!-- Right column end -->

    <!-- Left column start -->
    <div class="col-xl-9 col-lg-12 pull-xl-3 filter-bar">
      <invite-manager-nav-tabs
        [config]="config"
        (setListTo)="setListTo($event)"
      >
      </invite-manager-nav-tabs>
      <invite-card-list
        [limit]="9"
        [config]="config"
        (fetchInviteUsers)="fetchInviteUsers($event)"
      ></invite-card-list>
    </div>
    <!-- Left column end -->
  </div>
</div>
